<template>
  <div class="smile-foot emoj-action-foot" @click="toggleEmojGroupList">
    <a href="javascript:;" class="action-circle"><i class="bx bx-smile"></i></a>

    <div
      class="emoj-group-list-foot down-emoji-circle"
      :style="{ display: emojGroupListVisible ? 'block' : 'none' }"
    >
      <ul>
        <li
          v-for="(emoji, index) in list"
          :key="index"
          @click.prevent="$emit('select', emoji)"
        >
          <a href="javascript:;" class="emoji-symbol">{{emoji}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      emojGroupListVisible: false,
    };
  },

  methods: {
    toggleEmojGroupList() {
      this.emojGroupListVisible = !this.emojGroupListVisible;
    },
  },
};
</script>
